import React from "react";
import avatar from "../assets/avatar.png";
import { MdShoppingBasket, MdAdd, MdLogout } from "react-icons/md";
import { FaUserCheck } from "react-icons/fa";
import { motion } from "framer-motion";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { app } from "../firebase.config";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import { Link } from "react-router-dom";
import { useState } from "react";
import { AiOutlineMenuUnfold, AiOutlineMenuFold } from "react-icons/ai";

function Navbar() {
  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();

  const [{ user, cartItems }, dispatch] = useStateValue();
  const [isMenu, setIsMenu] = useState(false);

  const login = async () => {
    if (!user) {
      const {
        user: { refreshToken, providerData },
      } = await signInWithPopup(firebaseAuth, provider);
      dispatch({
        type: actionType.SET_USER,
        user: providerData[0],
      });
      localStorage.setItem("user", JSON.stringify(providerData[0]));
    } else {
      setIsMenu(!isMenu);
    }
  };

  const [toggleNav, setToggleNav] = useState(false);

  const handleNavToggle = () => {
    if (toggleNav) {
      setToggleNav(false);
    }
  };

  const logout = () => {
    setIsMenu(false);
    localStorage.clear();

    dispatch({
      type: actionType.SET_USER,
      user: null,
    });
  };

  return (
    <>
      <div className="bg-amber-50 shadow-lg  sticky top-0 z-10 hidden md:block">
        <nav className=" flex justify-between items-center gap-3 border-gray-200 px-2 sm:px-4 py-2.5  ">
          <Link to={"/"} className="flex items-center">
            <h1>Foodie</h1>
          </Link>
          <div className="flex items-center gap-8">
            <div className="flex">
              <Link to={'/'}>
              <a href="#" className="nav-link">
                Home
              </a>
              </Link>
              
              <Link to={'/'}>
              <a href="#" className="nav-link">
                Menu
              </a>
              </Link>
              <Link to={'/'}>
              <a href="#" className="nav-link">
                Services
              </a>
              </Link>
              
            </div>
            <Link to={'/cart'}>
            <motion.div
              whileTap={{ scale: 0.6 }}
              className="  flex items-center justify-center w-[40px] h-[40px] rounded-full bg-orange-500 relative"
            >
              <MdShoppingBasket className=" text-xl text-white cursor-pointer" />
              {cartItems && cartItems.length > 0 && (
                <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-red-600 flex items-center justify-center">
                <p className="text-sm text-white font-semibold">{cartItems.length}</p>
              </div>
              )}
            </motion.div>
            </Link>
            
            <div className="relative">
              <motion.a
                whileTap={{ scale: 0.6 }}
                className=" flex items-center justify-center w-[40px] h-[40px] rounded-full bg-orange-500 "
                onClick={login}
              >
                <img
                  src={user ? user.photoURL : avatar}
                  alt=""
                  className="rounded-full"
                />
              </motion.a>
              {isMenu && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.6 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.6 }}
                  className="w-60 bg-amber-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0"
                >
                  <p className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-200 ease-in-out text-base">
                    <FaUserCheck className="" />
                    Logged in as {user.displayName}
                  </p>
                  {user && user.email === "antonykibet03@gmail.com" && (
                    <Link to={"/createItem"}>
                      <p className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-200 ease-in-out text-base">
                        <MdAdd />
                        New Item
                      </p>
                    </Link>
                  )}
                  <p
                    className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-200 ease-in-out text-base"
                    onClick={logout}
                  >
                    <MdLogout />
                    Logout
                  </p>
                </motion.div>
              )}
            </div>
          </div>
        </nav>
      </div>

      {/********************************************************  mobile #########################################*/}
      <div className="p-3 flex items-center justify-between md:hidden shadow-lg bg-amber-50 sticky top-0 z-10">
        <Link to={"/"} className="flex items-center">
          <h1>Foodie</h1>
        </Link>
        <div className="flex items-center gap-4">
          <Link to={'/cart'}>
          <motion.div
            whileTap={{ scale: 0.6 }}
            className=" relative flex items-center justify-center w-[40px] h-[40px] rounded-full bg-orange-500 "
          >
            <MdShoppingBasket className="text-xl text-white cursor-pointer" />
            {cartItems && cartItems.length > 0 && (
                <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-red-600 flex items-center justify-center">
                <p className="text-sm text-white font-semibold">{cartItems.length}</p>
              </div>
              )}
          </motion.div>
          </Link>
          
          <div className="relative">
            <motion.a
              whileTap={{ scale: 0.6 }}
              className=" flex items-center justify-center w-[40px] h-[40px] rounded-full bg-orange-500 "
              onClick={login}
            >
              <img
                src={user ? user.photoURL : avatar}
                alt=""
                className="rounded-full"
              />
            </motion.a>
            {isMenu && (
              <motion.div
                initial={{ opacity: 0, scale: 0.6 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.6 }}
                className="w-60 bg-amber-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0"
              >
                <p className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-200 ease-in-out text-base">
                  <FaUserCheck className="" />
                  Logged in as  {user.displayName}
                </p>
                {user && user.email === "antonykibet03@gmail.com" && (
                  <Link to={"/createItem"}>
                    <p className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-200 ease-in-out text-base">
                      <MdAdd />
                      New Item
                    </p>
                  </Link>
                )}
                <p
                  className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-200 ease-in-out text-base"
                  onClick={logout}
                >
                  <MdLogout />
                  Logout
                </p>
              </motion.div>
            )}
          </div>

          <span
            className={`nav-open ${!toggleNav && "z-10"}`}
            onClick={() => setToggleNav(true)}
          >
            <AiOutlineMenuFold className="text-white text-xl" />
          </span>
          <nav className={`nav ${toggleNav && "right-0"} z-10`}>
            <div className="nav-container">
              <AiOutlineMenuUnfold
                className="nav-close"
                onClick={() => handleNavToggle()}
              />
              <ul className="nav-ul">
                <li>
                  <Link to={'/'}>
                  <a href="#" className="nav-link" onClick={() => setToggleNav(false)}>
                    Home
                  </a>
                  </Link>
                  
                </li>
                <li>
                <Link to={'/menu'} onClick={() => setToggleNav(false)}>
                  <a href="#" className="nav-link">
                    Menu
                  </a>
                  </Link>
                </li>
                <li>
                <Link to={'/'} onClick={() => setToggleNav(false)}>
                  <a href="#" className="nav-link">
                    Services
                  </a>
                  </Link>
                </li>
                
              </ul>
              
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Navbar;
